import { createGlobalStyle } from "styled-components";

export const theme = {
  red: "#ff0000",
  blue: "#0000ff",
  // black: "#232023",
  black: "#212D32",
  grey: "#3a3a3a",
  lightgrey: "#ccc",
  offWhite: "#ddd",
  purple: "#484389",
  maxWidth: "1440px",
  bs: "0 12px 24px 0 rgba(0,0,0,0.09)",
  primary: "#2a3040",
  // secondary: "#14cbc4",
  secondary: "#3d435b",
  accent: "#e535ab",
  tertiary: "#c1cfda",
  warning: "#f6bd60",
  danger: "#e63462",
  link: "#03a9db",
  hot: "#bd3694",
  success: "#03a9db",
  background: "#f7f8fa",
  white: "#f4f4f4",
  medgrey: "#d8d9e0",
  text: "#343c5a",
  textSecondary: "#747790",
  navbarHeight: "90px",
  navbarContainer: "150px",
  sidebarWidth: "200px",
  fontFamily: "Quicksand"
};

export const GlobalStyles = createGlobalStyle`
  
`;

export default {
  GlobalStyles,
  theme
};
